import { Input, InfoBox } from '@ics-portal/guardian';
import { ModalDivided } from '@components/_atoms/ModalDivided/ModalDivided';
import { type ReactNode, useEffect } from 'react';
import { Controller, useFormContext } from 'react-hook-form';
import { LatLng } from 'leaflet';
import { Section } from '@components/shared/Section';
import { type ProjectFormAttributes } from '../../ProjectForm';
import { ProjectLocationEditor } from '../../../ProjectLocationEditor/ProjectLocationEditor';

export function ProjectFormCustomer(): ReactNode {
    const { register, watch, control, setValue } =
        useFormContext<ProjectFormAttributes>();
    const longitude = watch('longitude');
    const latitude = watch('latitude');

    useEffect(() => {
        if (latitude === undefined || longitude === undefined) {
            setValue('pointInput', undefined);
            return;
        }
        setValue('pointInput', {
            latitude: Number(latitude),
            longitude: Number(longitude),
        });
    }, [latitude, longitude, setValue]);

    const latLng =
        latitude !== undefined && longitude !== undefined
            ? new LatLng(latitude, longitude)
            : undefined;

    return (
        <div className="flex flex-column gap-3">
            <InfoBox>
                Please add customer information and project location if
                necessary.
            </InfoBox>
            <ModalDivided>
                <Section title="Customer" className="gap-0">
                    <Input
                        id="customerName"
                        label="Name"
                        {...register('customerName', { required: true })}
                    />
                    <Input
                        id="customerEmail"
                        label="Email"
                        {...register('customerEmail')}
                    />
                    <Input
                        id="customerPhone"
                        label="Phone"
                        {...register('customerPhone')}
                    />
                    <Input
                        id="customerAddress"
                        label="Address"
                        {...register('customerAddress')}
                    />
                    <Input
                        id="plantName"
                        label="Plant Name"
                        {...register('plantName')}
                    />
                    <Input
                        id="plantExternalID"
                        label="Plant External ID"
                        {...register('plantExternalID')}
                    />
                </Section>
                <Section title="Project Location" className="gap-0">
                    <Input
                        id="locationStreet"
                        label="Street"
                        {...register('locationStreet')}
                    />
                    <Input
                        id="locationPostalCode"
                        label="Postal Code"
                        {...register('locationPostalCode')}
                    />
                    <Input
                        id="locationCity"
                        label="City"
                        {...register('locationCity')}
                    />
                    <Input
                        id="locationCountry"
                        label="Country"
                        {...register('locationCountry')}
                    />
                    <Input
                        id="longitude"
                        label="Longitude"
                        type="number"
                        {...register('longitude')}
                    />
                    <Input
                        id="latitude"
                        label="Latitude"
                        type="number"
                        {...register('latitude')}
                    />
                    <div className="flex justify-content-end">
                        <Controller
                            name="pointInput"
                            control={control}
                            render={({ field }) => (
                                <ProjectLocationEditor
                                    latLng={latLng}
                                    buttonProps={{
                                        label: 'Select location on map',
                                    }}
                                    onChange={(e) => {
                                        field.onChange({
                                            latitude: e.lat,
                                            longitude: e.lng,
                                        });

                                        setValue('latitude', e.lat, {
                                            shouldDirty: true,
                                        });
                                        setValue('longitude', e.lng, {
                                            shouldDirty: true,
                                        });
                                    }}
                                />
                            )}
                        />
                    </div>
                </Section>
            </ModalDivided>
        </div>
    );
}
